// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file bfftypes/v1/label.proto (package bfftypes.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file bfftypes/v1/label.proto.
 */
export const file_bfftypes_v1_label: GenFile = /*@__PURE__*/
  fileDesc("ChdiZmZ0eXBlcy92MS9sYWJlbC5wcm90bxILYmZmdHlwZXMudjEiLAoLVG9nZ2xlTGFiZWwSDgoGc3RhdHVzGAEgASgIEg0KBWxhYmVsGAIgASgJItMBCgtTdGF0dXNMYWJlbBIvCgZzdGF0dXMYASABKA4yHy5iZmZ0eXBlcy52MS5TdGF0dXNMYWJlbC5TdGF0dXMSDQoFbGFiZWwYAiABKAkigwEKBlN0YXR1cxIWChJTVEFUVVNfVU5TUEVDSUZJRUQQABISCg5TVEFUVVNfTkVVVFJBTBABEg8KC1NUQVRVU19JTkZPEAISEwoPU1RBVFVTX1BPU0lUSVZFEAMSEwoPU1RBVFVTX05FR0FUSVZFEAQSEgoOU1RBVFVTX1dBUk5JTkcQBSKXAgoKQWxlcnRMYWJlbBIuCgZzdGF0dXMYASABKA4yHi5iZmZ0eXBlcy52MS5BbGVydExhYmVsLlN0YXR1cxIMCgR0ZXh0GAIgASgJEhkKDGFsZXJ0X3RhcmdldBgDIAEoCUgAiAEBEhIKBXRpdGxlGAQgASgJSAGIAQEigAEKBlN0YXR1cxIWChJTVEFUVVNfVU5TUEVDSUZJRUQQABIQCgxTVEFUVVNfRVJST1IQARITCg9TVEFUVVNfUE9TSVRJVkUQAhIPCgtTVEFUVVNfSU5GTxADEhIKDlNUQVRVU19XQVJOSU5HEAQSEgoOU1RBVFVTX05FVVRSQUwQBUIPCg1fYWxlcnRfdGFyZ2V0QggKBl90aXRsZSIjCgZPcHRpb24SCgoCaWQYASABKAkSDQoFbGFiZWwYAiABKAlCsQEKD2NvbS5iZmZ0eXBlcy52MUIKTGFiZWxQcm90b1ABWkVnaXRodWIuY29tL2VuZWNoYWluL2Vwb3NpdGlvbi1hcHAvYmFja2VuZC9nZW4vcHJvdG8vYmZmdHlwZXMvdjE7dHlwZXOiAgNCWFiqAgtCZmZ0eXBlcy5WMcoCC0JmZnR5cGVzXFYx4gIXQmZmdHlwZXNcVjFcR1BCTWV0YWRhdGHqAgxCZmZ0eXBlczo6VjFiBnByb3RvMw");

/**
 * @generated from message bfftypes.v1.ToggleLabel
 */
export type ToggleLabel = Message<"bfftypes.v1.ToggleLabel"> & {
  /**
   * @generated from field: bool status = 1;
   */
  status: boolean;

  /**
   * @generated from field: string label = 2;
   */
  label: string;
};

/**
 * Describes the message bfftypes.v1.ToggleLabel.
 * Use `create(ToggleLabelSchema)` to create a new message.
 */
export const ToggleLabelSchema: GenMessage<ToggleLabel> = /*@__PURE__*/
  messageDesc(file_bfftypes_v1_label, 0);

/**
 * @generated from message bfftypes.v1.StatusLabel
 */
export type StatusLabel = Message<"bfftypes.v1.StatusLabel"> & {
  /**
   * @generated from field: bfftypes.v1.StatusLabel.Status status = 1;
   */
  status: StatusLabel_Status;

  /**
   * @generated from field: string label = 2;
   */
  label: string;
};

/**
 * Describes the message bfftypes.v1.StatusLabel.
 * Use `create(StatusLabelSchema)` to create a new message.
 */
export const StatusLabelSchema: GenMessage<StatusLabel> = /*@__PURE__*/
  messageDesc(file_bfftypes_v1_label, 1);

/**
 * @generated from enum bfftypes.v1.StatusLabel.Status
 */
export enum StatusLabel_Status {
  /**
   * @generated from enum value: STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: STATUS_NEUTRAL = 1;
   */
  NEUTRAL = 1,

  /**
   * @generated from enum value: STATUS_INFO = 2;
   */
  INFO = 2,

  /**
   * @generated from enum value: STATUS_POSITIVE = 3;
   */
  POSITIVE = 3,

  /**
   * @generated from enum value: STATUS_NEGATIVE = 4;
   */
  NEGATIVE = 4,

  /**
   * @generated from enum value: STATUS_WARNING = 5;
   */
  WARNING = 5,
}

/**
 * Describes the enum bfftypes.v1.StatusLabel.Status.
 */
export const StatusLabel_StatusSchema: GenEnum<StatusLabel_Status> = /*@__PURE__*/
  enumDesc(file_bfftypes_v1_label, 1, 0);

/**
 * @generated from message bfftypes.v1.AlertLabel
 */
export type AlertLabel = Message<"bfftypes.v1.AlertLabel"> & {
  /**
   * @generated from field: bfftypes.v1.AlertLabel.Status status = 1;
   */
  status: AlertLabel_Status;

  /**
   * @generated from field: string text = 2;
   */
  text: string;

  /**
   * @generated from field: optional string alert_target = 3;
   */
  alertTarget?: string;

  /**
   * @generated from field: optional string title = 4;
   */
  title?: string;
};

/**
 * Describes the message bfftypes.v1.AlertLabel.
 * Use `create(AlertLabelSchema)` to create a new message.
 */
export const AlertLabelSchema: GenMessage<AlertLabel> = /*@__PURE__*/
  messageDesc(file_bfftypes_v1_label, 2);

/**
 * @generated from enum bfftypes.v1.AlertLabel.Status
 */
export enum AlertLabel_Status {
  /**
   * @generated from enum value: STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: STATUS_ERROR = 1;
   */
  ERROR = 1,

  /**
   * @generated from enum value: STATUS_POSITIVE = 2;
   */
  POSITIVE = 2,

  /**
   * @generated from enum value: STATUS_INFO = 3;
   */
  INFO = 3,

  /**
   * @generated from enum value: STATUS_WARNING = 4;
   */
  WARNING = 4,

  /**
   * @generated from enum value: STATUS_NEUTRAL = 5;
   */
  NEUTRAL = 5,
}

/**
 * Describes the enum bfftypes.v1.AlertLabel.Status.
 */
export const AlertLabel_StatusSchema: GenEnum<AlertLabel_Status> = /*@__PURE__*/
  enumDesc(file_bfftypes_v1_label, 2, 0);

/**
 * @generated from message bfftypes.v1.Option
 */
export type Option = Message<"bfftypes.v1.Option"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string label = 2;
   */
  label: string;
};

/**
 * Describes the message bfftypes.v1.Option.
 * Use `create(OptionSchema)` to create a new message.
 */
export const OptionSchema: GenMessage<Option> = /*@__PURE__*/
  messageDesc(file_bfftypes_v1_label, 3);

